import {
    useState,
    useEffect,
} from "react";

import { SPORTS }
    from "../data/courts";

import { getCourts }
    from "../services/courtService";

import { generateTimeSlots }
    from "../services/slotService";

import {
    subscribeToSlots,
} from "../services/slotDBService";

import {
    createSlotId
} from "../services/cartService";

import { useCart }
    from "../context/CartContext";

import { useAuth }
    from "../context/AuthContext";

import SportTabs
    from "../components/booking/SportTabs";

import DateSelector
    from "../components/booking/DateSelector";

import CourtGrid
    from "../components/booking/CourtGrid";

import TimeSlotsPanel
    from "../components/booking/TimeSlotsPanel";

import BookingNotification
    from "../components/booking/BookingNotification";

import DailyLimitBanner
    from "../components/booking/DailyLimitBanner";

import {
    getTodayET
} from "../utils/timeUtils";

function SearchResultsPage() {

    const {

        items,

        replaceCart,

        addToCart,

        removeFromCart,

        hasTimeSlotConflict,

        getDurationForDate,

        getCartDurationForDate,

        getConfirmedDurationForDate,

    } = useCart();

    const {
        currentUser
    } = useAuth();

    const [courts, setCourts]
        = useState([]);

    const [activeSport, setActiveSport]
        = useState("badminton");

    const [selectedCourt, setSelectedCourt]
        = useState(null);

    const [selectedDate, setSelectedDate]
        = useState(
            getTodayET()
        );

    const [timeSlots, setTimeSlots]
        = useState([]);

    const [notification, setNotification]
        = useState(null);

    /* ---------------------------------- */
    /* LOAD COURTS */
    /* ---------------------------------- */

    useEffect(() => {

        async function loadCourts() {

            try {

                const data =
                    await getCourts();

                setCourts(data);

            } catch (error) {

                console.error(
                    "Failed to load courts:",
                    error
                );
            }
        }

        loadCourts();

    }, []);

    /* ---------------------------------- */
    /* FILTER COURTS */
    /* ---------------------------------- */

    const filteredCourts =
        courts.filter(
            (court) =>
                court.sport ===
                activeSport
        );

    /* ---------------------------------- */
    /* DURATION */
    /* ---------------------------------- */

    const confirmedDuration =
        getConfirmedDurationForDate(
            selectedDate
        );

    const cartDuration =
        getCartDurationForDate(
            selectedDate
        );

    const currentDuration =
        getDurationForDate(
            selectedDate
        );

    const currentMinutes =
        currentDuration * 60;

    /* ---------------------------------- */
    /* DEBUG */
    /* ---------------------------------- */

    console.log(
        "confirmedDuration",
        confirmedDuration
    );

    console.log(
        "cartDuration",
        cartDuration
    );

    console.log(
        "currentDuration",
        currentDuration
    );

    /* ---------------------------------- */
    /* RESET WHEN SPORT CHANGES */
    /* ---------------------------------- */

    useEffect(() => {

        setSelectedCourt(null);

        setTimeSlots([]);

    }, [activeSport]);

    /* ---------------------------------- */
    /* NOTIFICATION */
    /* ---------------------------------- */

    const notify = (

        msg,

        ok = true

    ) => {

        setNotification({

            msg,

            ok,
        });

        setTimeout(() => {

            setNotification(null);

        }, 3000);
    };

    /* ---------------------------------- */
    /* REALTIME SLOT AVAILABILITY */
    /* ---------------------------------- */

    useEffect(() => {

        if (!selectedCourt) {
            return;
        }

        const unsubscribe =
            subscribeToSlots({

                courtId:
                    selectedCourt.id,

                date:
                    selectedDate,

                callback:
                    (firestoreSlots) => {

                        /* ---------------------- */
                        /* BOOKED SLOT IDS */
                        /* ---------------------- */

                        const bookedSlotIds =
                            firestoreSlots

                                .filter((slot) => {

                                    return (
                                        slot.status ===
                                        "booked"
                                    );
                                })

                                .map(
                                    (slot) =>
                                        slot.slotId
                                );

                        /* ---------------------- */
                        /* CLEAN CART */
                        /* ---------------------- */

                        const cleanedCart =
                            items.filter(
                                (item) =>

                                    !bookedSlotIds.includes(
                                        item.slotId
                                    )
                            );

                        if (
                            cleanedCart.length !==
                            items.length
                        ) {

                            replaceCart(
                                cleanedCart
                            );

                            notify(
                                "Some slots were booked by another user.",
                                false
                            );
                        }

                        /* ---------------------- */
                        /* GENERATE UI SLOTS */
                        /* ---------------------- */

                        const uiSlots =
                            generateTimeSlots(
                                selectedCourt
                            );

                        /* ---------------------- */
                        /* MERGE FIRESTORE */
                        /* ---------------------- */

                        const mergedSlots =
                            uiSlots.map(
                                (uiSlot) => {

                                    const slotId =
                                        createSlotId(

                                            selectedCourt.id,

                                            selectedDate,

                                            uiSlot.startHour
                                        );

                                    const firestoreSlot =
                                        firestoreSlots.find(

                                            (slot) =>

                                                slot.slotId ===
                                                slotId
                                        );

                                    const isBooked =

                                        firestoreSlot?.status ===
                                        "booked";

                                    const bookedByMe =

                                        firestoreSlot?.bookedBy ===
                                        currentUser?.uid;

                                    return {

                                        ...uiSlot,

                                        slotId,

                                        status:
                                            firestoreSlot?.status
                                            || "available",

                                        booked:
                                            isBooked,

                                        bookedBy:
                                            firestoreSlot?.bookedBy
                                            || null,

                                        bookingId:
                                            firestoreSlot?.bookingId
                                            || null,

                                        bookedByMe,
                                    };
                                }
                            );

                        setTimeSlots(
                            mergedSlots
                        );
                    },
            });

        return () => {

            unsubscribe();
        };

    }, [

        selectedCourt,

        selectedDate,

        items,

        replaceCart,

        currentUser,
    ]);

    /* ---------------------------------- */
    /* ADD TO CART */
    /* ---------------------------------- */

    const handleAdd = (slot) => {

        const isBooked =

            slot.status ===
            "booked";

        /* BOOKED CHECK */

        if (isBooked) {

            if (slot.bookedByMe) {

                notify(
                    "You already booked this slot.",
                    false
                );

            } else {

                notify(
                    "Slot already booked.",
                    false
                );
            }

            return;
        }

        /* DAILY LIMIT */

        const projectedMinutes =

            currentMinutes +

            (slot.duration * 60);

        if (

            projectedMinutes >

            120

        ) {

            notify(
                "Daily booking limit is 2 hours.",
                false
            );

            return;
        }

        const slotId =
            createSlotId(

                selectedCourt.id,

                selectedDate,

                slot.startHour
            );

        const result =
            addToCart({

                id:
                    crypto.randomUUID(),

                slotId,

                courtId:
                    selectedCourt.id,

                courtName:
                    selectedCourt.name,

                sport:
                    selectedCourt.sport,

                date:
                    selectedDate,

                timeSlot:
                    slot.time,

                startHour:
                    slot.startHour,

                endHour:
                    slot.endHour,

                duration:
                    slot.duration,

                price:
                    selectedCourt.pricePerHour *
                    slot.duration,

                location:
                    selectedCourt.location,
            });

        if (result.success) {

            notify(
                "Added to cart"
            );

        } else {

            notify(
                result.message,
                false
            );
        }
    };

    /* ---------------------------------- */
    /* REMOVE */
    /* ---------------------------------- */

    const handleRemove = () => {

        notify(
            "Removed from cart",
            false
        );
    };

    return (

        <div style={styles.page}>

            <div style={styles.overlay}>

                <div style={styles.container}>

                    {/* HEADER */}

                    <div style={styles.header}>

                        <h1 style={styles.title}>
                            Available Courts
                        </h1>

                        <p style={styles.subtitle}>
                            Choose a sport,
                            pick a date,
                            and select your time slot
                        </p>

                    </div>

                    {/* NOTIFICATION */}

                    <BookingNotification
                        notification={
                            notification
                        }
                    />

                    {/* DAILY LIMIT */}

                    <DailyLimitBanner
                        currentDuration={
                            currentDuration
                        }
                    />

                    {/* SPORT TABS */}

                    <SportTabs
                        sports={SPORTS}

                        activeSport={
                            activeSport
                        }

                        setActiveSport={
                            setActiveSport
                        }
                    />

                    {/* DATE */}

                    <DateSelector
                        selectedDate={
                            selectedDate
                        }

                        setSelectedDate={
                            setSelectedDate
                        }
                    />

                    {/* COURTS */}

                    <CourtGrid

                        courts={
                            filteredCourts
                        }

                        selectedCourt={
                            selectedCourt
                        }

                        setSelectedCourt={
                            setSelectedCourt
                        }
                    />

                    {/* TIME SLOTS */}

                    <TimeSlotsPanel

                        selectedCourt={
                            selectedCourt
                        }

                        selectedDate={
                            selectedDate
                        }

                        timeSlots={
                            timeSlots
                        }

                        onAdd={
                            handleAdd
                        }

                        onRemove={(id) => {

                            removeFromCart(id);

                            handleRemove();
                        }}

                        hasConflict={(slot) =>

                            hasTimeSlotConflict(

                                selectedDate,

                                slot.startHour,

                                slot.endHour
                            )
                        }
                    />

                </div>

            </div>

        </div>
    );
}

const styles = {

    page: {

        minHeight:
            "100vh",

        background:
            "linear-gradient(111.1deg, rgb(0,40,70) -4.8%, rgb(255,229,115) 82.7%, rgb(255,203,15) 97.2%)",

        padding:
            "40px 20px",
    },

    overlay: {

        minHeight:
            "100vh",

        backdropFilter:
            "blur(3px)",
    },

    container: {

        maxWidth:
            "1300px",

        margin:
            "0 auto",
    },

    header: {

        marginBottom:
            "30px",
    },

    title: {

        color:
            "#ffffff",

        fontSize:
            "42px",

        fontWeight:
            "800",

        marginBottom:
            "10px",

        letterSpacing:
            "-1px",

        textShadow:
            "0 2px 20px rgba(0,0,0,0.25)",
    },

    subtitle: {

        color:
            "#d1d5db",

        fontSize:
            "16px",

        lineHeight:
            "24px",

        maxWidth:
            "650px",
    },
};

export default SearchResultsPage;